import { Trans, useTranslation } from 'next-i18next'
// Lib.
import styled, { css } from 'styled-components'
import Link from 'next/link'

// Comps
import { NookEvent } from '../types'
import {
  colors,
  icons,
  eventIsAboutToStart,
  eventHasFreeSpaces,
  show,
  showFinally,
} from '../utils'
import { H6, H4, P } from './Headings'
import { DateAndTime } from './Event/Hero/DateAndTime'
import { JoinNow } from './CTAs/JoinNow'
import { useAnalyticsEvent } from '../hooks/analyticsEvent'
import { eventItemStyles } from './eventItemStyles'
import { EventTypeBadge as EventTypeBadgeBase } from './EventTypeBadge'

const EventTypeBadge = styled(EventTypeBadgeBase)`
  position: absolute;
  top: 8px;
  left: 8px;
`
// Styles
const Container = styled.div<StyleProps>`
  ${eventItemStyles}
`

// Defs
interface EventStateInfo {
  eventText: string
  eventTextColor: string
}

interface Props {
  event: NookEvent
  page: string
  showInvitedBanner?: boolean
  showFreeSpaceBanner?: boolean
}

interface StyleProps {
  bgColor?: string
  eventStateColor?: string
}

// Field.
export const EventItem: React.FC<Props> = (props) => {
  const { t } = useTranslation('common')
  // Props
  const { event, page, showInvitedBanner, showFreeSpaceBanner } = props
  const eventImage = event.image_url || event.image

  // Global State
  const analyticsEvent = useAnalyticsEvent()

  const eventHostName = event?.host?.name || ''
  return (
    <Container
      onClick={() => {
        analyticsEvent.discoverViewEvent(page)
      }}
      bgColor={event?.category?.background_colour}
      eventStateColor={getEventState(event)?.eventTextColor}>
      {show(showInvitedBanner === true) && (
        <>
          <div className="event-invite">
            <P>
              <Trans i18nKey="invited you to">
                {{ eventHostName }} invited you to:
              </Trans>
            </P>
          </div>
        </>
      )}

      {/* Poster Image */}
      <div className="background">
        {/* background Content */}
        {show(eventImage !== null) && (
          <>
            <img className="eventImage" src={eventImage}></img>
          </>
        )}
        {showFinally(eventImage === null) && (
          <>
            <div className="cate-icon">{event?.category?.emoji || ''}</div>
          </>
        )}
        <EventTypeBadge event={event} />

        {/* Chips that appear on top of the background */}

        <div className="overlays">
          {/* Show user if there is a free space - normally used when displaying a waiting list */}
          {show(
            eventHasFreeSpaces(event) === true && showFreeSpaceBanner === true,
          ) && (
            <>
              <div className="event-state-open-spaces">
                <H6 className="event-state-text">
                  {t(`Space open`, `Space open`)}
                </H6>
              </div>
            </>
          )}

          {/* Show state or join if has started */}
          {show(eventIsAboutToStart(event) === false) && (
            <>
              {/* <div className="eventState">
            <H6 className="eventStateText">{getEventState(event).eventText}</H6>
          </div> */}
            </>
          )}
          {showFinally(eventIsAboutToStart(event) === true) && (
            <>
              {/* <JoinNow video_url={event.video_url} user_is_host={event.is_user_host} /> */}
            </>
          )}

          {/* Show private lock if private */}
          {show(event.event_type === 1) && (
            <>
              <div className="eventType">
                <img
                  className="privateIcon"
                  src="/icons/icon-eye-close-inverted.svg"
                  alt={t(`Event is private`, `Event is private`)}
                />
              </div>
            </>
          )}
        </div>
      </div>

      {/* ABS Link over the top of the card */}
      <Link href={`/events/${event.id}`}>
        <a className="eventLink"></a>
      </Link>

      {/* bottom text START */}
      <div className="eventTime">
        <DateAndTime dateTime={event.start_date}></DateAndTime>
      </div>

      <H4 className="eventTitle">{event.title}</H4>
      {/* {event.hosted_group && <Link href={`/pages/${event.hosted_group.url}`}>
      <a className="pageLink"><H6>{event.hosted_group.name || ''}</H6></a>
    </Link>} */}
      {/* Bottom Text END */}
    </Container>
  )
}

const getEventState = (event: NookEvent) => {
  const result: EventStateInfo = {
    eventText: 'FREE',
    eventTextColor: colors.pink,
  }

  if (event.is_user_host) {
    result.eventText = 'HOSTING'
    result.eventTextColor = colors.purple
  } else if (event.is_user_going) {
    result.eventText = 'GOING'
    result.eventTextColor = colors.green
  } else if (event.event_paid_type === 1) {
    result.eventText = 'PAID'
    result.eventTextColor = colors.pink
  }
  return result
}
